/**
 * Computes the submit key for forecast submission.
 * Priority:
 * 1. Active allocation project's allocationName (trimmed)
 * 2. Non-empty financialYear (legacy)
 * 3. null if both are missing/empty
 *
 * @param {object} activeAllocationProject - The active allocation project
 * @param {string} financialYear - The financial year from workspace config
 * @returns {string|null} The submit key, or null if none available
 */
export const computeSubmitKey = (activeAllocationProject, financialYear) => {
  const allocationName = activeAllocationProject?.allocationName?.trim();

  if (allocationName) {
    return allocationName;
  }

  if (financialYear && financialYear.trim()) {
    return financialYear.trim();
  }

  return null;
};

/**
 * Checks if a group has been submitted for the current period.
 * Matches against the submit key, and also checks legacy financialYear for backwards compatibility.
 *
 * @param {string} forecastSubmittedFor - The period the forecast was submitted for
 * @param {string} submitKey - The current submit key
 * @param {string} financialYear - The financial year (for legacy matching)
 * @returns {boolean} Whether the forecast has been submitted for this period
 */
export const isSubmittedForCurrentPeriod = (
  forecastSubmittedFor,
  submitKey,
  financialYear
) => {
  if (!forecastSubmittedFor || !submitKey) {
    return false;
  }

  if (forecastSubmittedFor === submitKey) {
    return true;
  }

  if (financialYear && forecastSubmittedFor === financialYear) {
    return true;
  }

  return false;
};
